import * as yup from "yup";

export const cadastroListaFornecedoresSchema = yup.object().shape({
  id_lista: yup.number(),
  nome_lista: yup.string(),
  observacao: yup.string().default("").notRequired(),
  itens: yup
    .array(yup.number().required()) // Garante que os números sejam obrigatórios
    .nullable()
    .default(null),
});
